<template>
  <!-- CAPAS -->
  <div id="openCapas" class="capas-bar">
    <div class="wrap-capas">
      <div class="content-capas">
        <div class="row">
          <div class="col-11">
            <h5>CAPAS</h5>
          </div>
          <div class="col-1">
            <span data-v-ae1f03c5="" class="closeCampos close" @click="closeDialog">×</span>
          </div>
          <div class="col-12">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="flexCheckDefault"
                v-model="prediosLayer"
              />
              <label class="form-check-label" for="flexCheckDefault">
                <i class="bi bi-geo-alt"></i> PREDIOS
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="flexCheckDefault"
                v-model="regionesLayer"
              />
              <label class="form-check-label" for="flexCheckDefault">
                <i class="bi bi-geo-alt"></i> REGIONES
              </label>
            </div>

            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="flexCheckDefault"
                v-model="comunasLayer"
              />
              <label class="form-check-label" for="flexCheckDefault">
                <i class="bi bi-geo-alt"></i> COMUNAS
              </label>
            </div>

            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="flexCheckDefault"
                v-model="ciudadesLayer"
              />
              <label class="form-check-label" for="flexCheckDefault">
                <i class="bi bi-geo-alt"></i> CIUDADES
              </label>
            </div>

            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="flexCheckDefault"
                v-model="carreterasLayer"
              />
              <label class="form-check-label" for="flexCheckDefault">
                <i class="bi bi-geo-alt"></i> CARRETERAS
              </label>
            </div>

            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="flexCheckDefault"
                v-model="caminosPrincipalesLayer"
              />
              <label class="form-check-label" for="flexCheckDefault">
                <i class="bi bi-geo-alt"></i> CAMINOS PRINCIPALES
              </label>
            </div>

            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="flexCheckDefault"
                v-model="caminosVecinalesLayer"
              />
              <label class="form-check-label" for="flexCheckDefault">
                <i class="bi bi-geo-alt"></i> CAMINOS VECINALES
              </label>
            </div>

            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="flexCheckDefault"
                v-model="aguasLayer"
              />
              <label class="form-check-label" for="flexCheckDefault">
                <i class="bi bi-geo-alt"></i> AGUA
              </label>
            </div>

            <!--                    <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                            <label class="form-check-label" for="flexCheckDefault">
                                <i class="bi bi-geo-alt"></i> TETRA
                            </label>
                        </div>

                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                            <label class="form-check-label" for="flexCheckDefault">
                                <i class="bi bi-geo-alt"></i> INCENDIOS
                            </label>
                        </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FIN CAPAS -->
</template>
<script setup lang="ts">
import { ref, watch } from 'vue'
import { useGlobalStore } from '@/stores/global'
import { useServicesStore } from '@/stores/services'
import { storeToRefs } from 'pinia'

const global = useGlobalStore()
const {
  prediosLayer,
  regionesLayer,
  comunasLayer,
  ciudadesLayer,
  carreterasLayer,
  caminosPrincipalesLayer,
  caminosVecinalesLayer,
  aguasLayer,
  screenBounds
} = storeToRefs(global)

const serv = useServicesStore()
const {
  predios,
  regiones,
  comunas,
  ciudades,
  carreteras,
  caminosPrincipales,
  caminosVecinales,
  aguas
} = storeToRefs(serv)

const emit = defineEmits<{
  (event: 'closed'): void
}>()

// Definiciones de funciones
function closeDialog() {
  emit('closed')
}
// Watch para prediosLayer
watch(prediosLayer, (newValue) => {
  console.log('prediosLayer changed:', newValue)
  if (newValue) {
    if (predios.value === undefined || predios.value.features.length === 0) {
      serv.dispatchGetPredios()
    }
  }
})

// Watch para regionesLayer
watch(regionesLayer, (newValue) => {
  console.log('regionesLayer changed:', newValue)
  if (newValue) {
    if (regiones.value === undefined || regiones.value.features.length === 0) {
      // serv.dispatchGetRegiones(bounds.value.ne_lon, bounds.value.ne_lat, bounds.value.so_lon, bounds.value.so_lat);
    }
  }
})

// Watch para comunasLayer
watch(comunasLayer, (newValue) => {
  console.log('comunasLayer changed:', newValue)
  if (newValue) {
    if (comunas.value === undefined || comunas.value.features.length === 0) {
      serv.dispatchGetComunas()
    }
  }
})
watch(ciudadesLayer, (newValue) => {
  console.log('ciudadesLayer changed:', newValue)
  if (newValue) {
    if (ciudades.value === undefined || ciudades.value.features.length === 0) {
      serv.dispatchGetCiudades()
    }
  }
})

watch(carreterasLayer, (newValue) => {
  console.log('carreterasLayer changed:', newValue)
  if (newValue) {
    if (carreteras.value === undefined || carreteras.value.features.length === 0) {
      serv.dispatchGetCarreteras()
    }
  }
})

watch(caminosPrincipalesLayer, (newValue) => {
  console.log('caminosPrincipalesLayer changed:', newValue)
  if (newValue) {
    if (caminosPrincipales.value === undefined || caminosPrincipales.value.features.length === 0) {
      serv.dispatchGetCaminosPrincipales()
    }
  }
})

watch(caminosVecinalesLayer, (newValue) => {
  console.log('caminosVecinalesLayer changed:', newValue)
  if (newValue) {
    if (caminosVecinales.value === undefined || caminosVecinales.value.features.length === 0) {
      serv.dispatchGetCaminosVecinales()
    }
  }
})

watch(aguasLayer, (newValue) => {
  console.log('aguasLayer changed:', newValue)
  if (newValue) {
    if (aguas.value === undefined || aguas.value.features.length === 0) {
      serv.dispatchGetAguas()
    }
  }
})
</script>
<style lang="css" scoped>
.capas-bar {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 15;
  visibility: visible;
  opacity: 1;
}

@media (max-width: 576px) {
  .capas-bar {
    width: 60%;
  }

  .row {
    width: 100%;
    margin-left: 10px;
  }
}
</style>
